module.exports = __webpack_public_path__ + "static/media/Varys 2.45733b52.jpg";